import moment from 'moment';
import utils from '@/services/utils';

/**
 * Determines whether a subscription is_active and is not expired.
 */
function isAvailable(enrichedSubscription) {
  if (!enrichedSubscription) { return false; }
  return (
    enrichedSubscription.is_active
    && (enrichedSubscription.expires ? enrichedSubscription.expires > moment() : true)
  );
}

/**
 * Take a raw subscription and format datetime values with moment, camelCase the keys.
 */
function enrichSubscription(subscription) {
  if (!subscription) { return null; }
  const enriched = { ...subscription };
  enriched.created = moment(enriched.created_at);
  enriched.updated = moment(enriched.updated_at);
  enriched.expires = enriched.expires_at ? moment(enriched.expires_at) : null;
  enriched.available = isAvailable(enriched);
  return utils.keysToCamelCase(enriched);
}

/**
 * Filter Account Subscriptions down to a certain type. Assumes that we have a set of
 * Subscriptions for a single Account, where `type` will be unique among them.
 * @param {Array} subscriptions - The Account subscriptions.
 * @param {String} type - The type of Subscription we are looking for.
 * @return {null|Object} The Subscription in question
 */
function findSubscription(subscriptions, type) {
  const subscription = subscriptions.filter((s) => s.type === type).shift();
  if (!subscription) {
    return null;
  }
  return enrichSubscription(subscription);
}

export default {
  findSubscription,
  enrichSubscription,
  isAvailable,
};
